import { FETCH_COMPACTING_DC_DETAILS_RATE_FROM_STYLE_SUCCESS } from '../compactingDivision/compactingDivision.actionsType';
import {
    CREATE_COMPACTING_DC_DETAILS_FAILURE,
    CREATE_COMPACTING_DC_DETAILS_REQUEST,
    CREATE_COMPACTING_DC_DETAILS_SUCCESS,
    CREATE_USER_FORM_COMPACTING_DC_DETAILS,
    DELETE_COMPACTING_DC_DETAILS_FAILURE,
    DELETE_COMPACTING_DC_DETAILS_REQUEST,
    DELETE_COMPACTING_DC_DETAILS_SUCCESS,
    FETCH_SINGLE_COMPACTING_DC_DETAILS_FAILURE,
    FETCH_SINGLE_COMPACTING_DC_DETAILS_REQUEST,
    FETCH_SINGLE_COMPACTING_DC_DETAILS_SUCCESS,
    FETCH_COMPACTING_DC_DETAILS_FAILURE,
    FETCH_COMPACTING_DC_DETAILS_REQUEST,
    FETCH_COMPACTING_DC_DETAILS_SUCCESS,
    COMPACTING_DC_DETAILS_USERFORM_RESET,
    UPDATE_COMPACTING_DC_DETAILS_FAILURE,
    UPDATE_COMPACTING_DC_DETAILS_REQUEST,
    UPDATE_COMPACTING_DC_DETAILS_SUCCESS,
    FETCH_COMPACTING_DC_DETAILS_BY_ID_REQUEST,
    FETCH_COMPACTING_DC_DETAILS_BY_ID_SUCCESS,
    FETCH_COMPACTING_DC_PREVIOUS_LIST_REQUEST,
    FETCH_COMPACTING_DC_PREVIOUS_LIST_SUCCESS,
    FETCH_COMPACTING_DC_PREVIOUS_LIST_FAILURE,
    FETCH_GRN_NO_BY_COMPACTING_PO_REQUEST,
    FETCH_GRN_NO_BY_COMPACTING_PO_FAILURE,
    FETCH_GRN_NO_BY_COMPACTING_PO_SUCCESS,
    FETCH_COMPACTING_DC_DETAILS_DC_NO_REQUEST,
    FETCH_COMPACTING_DC_DETAILS_DC_NO_SUCCESS,
    FETCH_COMPACTING_DC_DETAILS_DC_NO_FAILURE,
    FETCH_COMPACTING_DC_DETAILS_PROGRAM_LIST_REQUEST,
    FETCH_COMPACTING_DC_DETAILS_PROGRAM_LIST_SUCCESS,
    FETCH_COMPACTING_DC_DETAILS_PROGRAM_LIST_FAILURE,
    COMPACTING_RESET_SELECTED_ID,
    COMPACTING_DC_PROGRAM_ID_SUCCESS,
    COMPACTING_DC_PROGRAM_ID_FAILURE,
    COMPACTING_DC_PROGRAM_ID_REQUEST,
    FETCH_COMPACTING_DIVISION_PREVIOUS_LIST_REQUEST,
    FETCH_COMPACTING_DIVISION_PREVIOUS_LIST_SUCCESS,
    FETCH_COMPACTING_DIVISION_PREVIOUS_LIST_FAILURE,
    FETCH_COMPACTING_DIVISION_DETAILS_EDIT_BY_ID_REQUEST,
    FETCH_COMPACTING_DIVISION_DETAILS_EDIT_BY_ID_SUCCESS,
    FETCH_COMPACTING_DIVISION_DETAILS_EDIT_BY_ID_FAILURE,
    DELETE_COMPACTING_DIVISION_DETAILS_BY_ID_REQUEST,
    DELETE_COMPACTING_DIVISION_DETAILS_BY_ID_FAILURE
} from './compactingDivisionDetails.actionsType';

export const COMPACTING_DIVISION_DETAILS = 'compactingDivisionDetails';

let initialState = {
    loading: false,
    compactingDCDetailsById: [],
    compactingDCDetails: [],
    previousList: [],
    grnNoByCompactingPO: [],
    compactingDCDetailsDcNo: [],
    rateKg: '',
    userform: {
        fldRate: 1.4,
        fldBCDia: 0,
        fldBCGSM: 0,
        fldACDia: 0,
        fldACGSM: 0,
        fldQuantity: 0,
        fldFKGSM: 0,
        fldGrossValue: 0,
        fldDiscountValue: 0,
        fldIGSTValue: 0,
        fldSGSTValue: 0,
        fldCGSTValue: 0,
        fldTaxableValue: 0,
        fldGSTValue: 0,
        fldSGSTPercentage: 0,
        fldCGSTPercentage: 0,
        fldIGSTPercentage: 0,
        fldFKBagWeight: 0,
        fldFKNoofRolls: 0,
        fldProcessLoss: 0,
        InwardNO: []
    },
    programList: {},
    selectedReceivingDetails: {},
    selectedKnittingDCDetails: {},
    errorMessage: '',
    iperrorMessage: ''
};

export let compactingDivisionDetailsReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;
    switch (type) {
        case FETCH_COMPACTING_DC_DETAILS_REQUEST:
        case FETCH_GRN_NO_BY_COMPACTING_PO_REQUEST:
        case FETCH_COMPACTING_DC_DETAILS_DC_NO_REQUEST:
        case FETCH_COMPACTING_DIVISION_PREVIOUS_LIST_REQUEST:
        case FETCH_COMPACTING_DC_DETAILS_BY_ID_REQUEST:
        case CREATE_COMPACTING_DC_DETAILS_REQUEST:
        case FETCH_SINGLE_COMPACTING_DC_DETAILS_REQUEST:
        case UPDATE_COMPACTING_DC_DETAILS_REQUEST:
        case DELETE_COMPACTING_DC_DETAILS_REQUEST:
        case FETCH_COMPACTING_DC_DETAILS_PROGRAM_LIST_REQUEST:
        case COMPACTING_DC_PROGRAM_ID_REQUEST:
        case FETCH_COMPACTING_DIVISION_DETAILS_EDIT_BY_ID_REQUEST:
        case DELETE_COMPACTING_DIVISION_DETAILS_BY_ID_REQUEST:
            return {
                ...state,
                loading: true
            };
        case FETCH_COMPACTING_DC_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                compactingDCDetails: updatePayload
            };
        case FETCH_COMPACTING_DC_DETAILS_PROGRAM_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                programList: updatePayload
            };
        case FETCH_GRN_NO_BY_COMPACTING_PO_SUCCESS:
            return {
                ...state,
                loading: false,
                grnNoByCompactingPO: updatePayload?.Inward
            };
        case FETCH_COMPACTING_DC_DETAILS_RATE_FROM_STYLE_SUCCESS: {
            return {
                ...state,
                loading: false,
                rateKg: updatePayload

            }
        }
        case FETCH_COMPACTING_DC_DETAILS_DC_NO_SUCCESS:
            return {
                ...state,
                loading: false,
                compactingDCDetailsDcNo: updatePayload?.COD
            };
        case FETCH_COMPACTING_DIVISION_PREVIOUS_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                previousList: updatePayload
            };
        case FETCH_COMPACTING_DC_DETAILS_BY_ID_SUCCESS:
            return {
                ...state,
                loading: false,
                compactingDCDetailsById: updatePayload
            };
        case COMPACTING_RESET_SELECTED_ID:
            return {
                ...state,
                prevId: updatePayload
            };

        case COMPACTING_DC_PROGRAM_ID_SUCCESS:
            return {
                ...state,
                fldFkProgramId: updatePayload.fldFKProgram
            }
        case CREATE_COMPACTING_DC_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: {
                    // fldRate: 0,
                    fldQuantity: 0,
                    fldFKGSM: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldFKBagWeight: 0,
                    fldFKNoofRolls: 0,

                    InwardNO: []
                },
                grnNoByCompactingPO: []
            };
        case FETCH_SINGLE_COMPACTING_DC_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: updatePayload[0]
            };
        case UPDATE_COMPACTING_DC_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                selectedKnittingDCDetails: {},
                userform: {
                    // fldRate: 0,
                    fldQuantity: 0,
                    fldFKGSM: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldFKBagWeight: 0,
                    fldFKNoofRolls: 0,
                    InwardNO: []
                }
            };
        case DELETE_COMPACTING_DC_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: {
                    // fldRate: 0,
                    fldQuantity: 0,
                    fldFKGSM: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldFKBagWeight: 0,
                    fldFKNoofRolls: 0,
                    InwardNO: []
                },
                selectedKnittingDCDetails: {}
            };
        case FETCH_COMPACTING_DIVISION_DETAILS_EDIT_BY_ID_SUCCESS:
            return {
                ...state,
                loading: false,
                selectedReceivingDetails: updatePayload,
                userform: updatePayload
            };
        case FETCH_COMPACTING_DC_DETAILS_FAILURE:
        case FETCH_GRN_NO_BY_COMPACTING_PO_FAILURE:
        case FETCH_COMPACTING_DC_DETAILS_DC_NO_FAILURE:
        case FETCH_COMPACTING_DIVISION_PREVIOUS_LIST_FAILURE:
        case FETCH_SINGLE_COMPACTING_DC_DETAILS_FAILURE:
        case CREATE_COMPACTING_DC_DETAILS_FAILURE:
        case UPDATE_COMPACTING_DC_DETAILS_FAILURE:
        case DELETE_COMPACTING_DC_DETAILS_FAILURE:
        case FETCH_COMPACTING_DC_DETAILS_PROGRAM_LIST_FAILURE:
        case COMPACTING_DC_PROGRAM_ID_FAILURE:
        case FETCH_COMPACTING_DIVISION_DETAILS_EDIT_BY_ID_FAILURE:
        case DELETE_COMPACTING_DIVISION_DETAILS_BY_ID_FAILURE:
            return {
                ...state,
                loading: false,
                errorMessage: updatePayload
            };
        case CREATE_USER_FORM_COMPACTING_DC_DETAILS:
            return {
                ...state,
                loading: false,
                userform: {
                    ...state.userform,
                    [payload.key]: payload.value
                }
            };
        case COMPACTING_DC_DETAILS_USERFORM_RESET:
            return {
                ...state,
                userform: {
                    fldRate: 1.4,
                    fldQuantity: 0,
                    fldFKGSM: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldFKBagWeight: 0,
                    fldFKNoofRolls: 0,
                    fldStyleNumber: '',
                    fldFKFabricGroup: '',
                    fldFKFabric: '',
                    fldFKYarnCount: '',
                    fldFKHSNCode: '',
                    fldFKColour: '',
                    fldFKUOM: " ",
                    fldProcessLoss: 0,
                    InwardNO: []
                },
                selectedKnittingDCDetails: {}
            };
        default:
            return state;
    }
};
